import { Component, OnInit, input, output } from '@angular/core';
import { WhitelabelIosIcons } from '../../models/whitelabel-ios-config';
import { getFileExtension } from '../../helpers/file.helper';
import { uploadedIconsAreTheExpected } from '../../helpers/validators.helper';

@Component({
  standalone: false,
  selector: 'app-whitelabel-ios-icons-upload',
  templateUrl: './whitelabel-ios-icons-upload.component.html',
  styleUrls: ['./whitelabel-ios-icons-upload.component.css']
})
export class WhitelabelIosIconsUploadComponent implements OnInit {

  public readonly type = input.required<'icons' | 'appIcon'>();

  public readonly errorEvent$ = output<void>();

  public readonly successEvent$ = output<File[] | File>();

  ngOnInit(): void {}

  public onIconsUpload(event: any): void {
    const files = event.target.files as FileList;
    const uploadedFiles = Array.from(files);

    if (!uploadedIconsAreTheExpected(uploadedFiles, WhitelabelIosIcons)) {
      this.errorEvent$.emit();
      return;
    }

    this.successEvent$.emit(uploadedFiles);
    return;
  }

  public onAppIconUpload(event: any): void {
    const files = event.target.files as FileList;
    const uploadedFile = files[0];
    
    if (uploadedFile) {
      const isValid = uploadedFile.name === 'logo.png';

      if (!isValid) {
        this.errorEvent$.emit();
        return;
      }

      this.successEvent$.emit(uploadedFile);
    }

    return;
  }

}
